// components/PDFViewer.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../styles/PDFViewer.module.css';
import { FaArrowLeft, FaDownload, FaExternalLinkAlt } from 'react-icons/fa';

export default function PDFViewer() {
  const location = useLocation();
  const navigate = useNavigate();
  const { pdfUrl, title } = location.state || {};

  useEffect(() => {
    if (!pdfUrl) {
      navigate(-1);
    }
  }, [pdfUrl, navigate]);

  if (!pdfUrl) return null;

  // Create Google Docs viewer URL
  //const googleDocsUrl = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(pdfUrl)}`;
  const googleDocsUrl = `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(pdfUrl)}`;


  return (
    <div className={styles.pdfViewerContainer}>
      <div className={styles.pdfViewerHeader}>
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back to Documents
        </button>

      </div>

      <div className={styles.pdfViewerContent}>
        <iframe
          src={googleDocsUrl}
          title={title || 'PDF Viewer'}
          className={styles.pdfIframe}
          frameBorder="0"
        />
      </div>
    </div>
  );
}